// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Constants for inventory overview table styling.
 */

export const INVENTORY_OVERVIEW_COLORS = {
  /** Blue theme for inventory locations and totals */
  INVENTORY: {
    /** Background color for inventory total cells */
    BACKGROUND: 'rgb(219, 234, 254)',
    /** Background color for inventory location cells (solid 20% equivalent) */
    LOCATION_BACKGROUND: 'rgb(246, 249, 253)',
    /** Background color for inventory total cells (solid 40% equivalent) */
    TOTAL_BACKGROUND: 'rgb(233, 242, 254)',
    /** Text color for inventory total labels */
    TEXT: 'rgb(30, 58, 138)',
  },
  /** Purple theme for non-inventory locations and totals */
  NON_INVENTORY: {
    /** Background color for non-inventory total cells */
    BACKGROUND: '#B39DDB',
    /** Background color for non-inventory location cells (solid 20% equivalent) */
    LOCATION_BACKGROUND: 'rgb(248, 245, 251)',
    /** Background color for non-inventory total cells (solid 40% equivalent) */
    TOTAL_BACKGROUND: 'rgb(241, 235, 247)',
    /** Text color for non-inventory total labels */
    TEXT: '#673AB7',
  },
  /** Orange theme for in transit totals */
  IN_TRANSIT: {
    /** Background color for individual in transit cells (solid 20% equivalent) */
    LOCATION_BACKGROUND: 'rgb(255, 251, 247)',
    /** Background color for in transit total cells (solid 40% equivalent) */
    TOTAL_BACKGROUND: 'rgb(254, 243, 235)',
    /** Text color for in transit total labels */
    TEXT: 'rgba(0, 0, 0, 0.87)',
  },
} as const;

export const INVENTORY_OVERVIEW_DIMENSIONS = {
  /** Standard width for data cells in the table */
  CELL_WIDTH: '175px',
  /** Minimum width for inventory locations section */
  INVENTORY_MIN_WIDTH: '300px',
  /** Minimum width for non-inventory locations section */
  NON_INVENTORY_MIN_WIDTH: '300px',
} as const;

/**
 * Special location keys for in-transit assets.
 * These match the backend constants in project/asset-manager/src/constants/inventory.go
 */
export const IN_TRANSIT_LOCATION_KEYS = {
  TO_INVENTORY: 'IN_TRANSIT_TO_INVENTORY',
  TO_FIELD: 'IN_TRANSIT_TO_FIELD',
} as const;
